import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { RUTAS_BITACORAS } from "../Rutas";
import LayoutGeneral from "../LayoutGeneral";
import "./BitacoraNueva_Seguimiento.css"; 

const Bitacora_Seguimiento = () => {
  const navigate = useNavigate();
  // Campo proveniente de la URL
  const { idBitacora } = useParams();
  const [bitacora, setBitacora] = useState(null);
  const [acuerdos, setAcuerdos] = useState([]);
  const EsAdmin = localStorage.getItem("admin");
  const roles = JSON.parse(localStorage.getItem('roles') || '[]');
const puedeVerReporte = roles.some(role => role.idRol === 1 || role.idRol === 2 || role.idRol === 3);

  // Modal / reapertura states
  const [showReapModal, setShowReapModal] = useState(false);
  const [reapComentario, setReapComentario] = useState("");
  const [pendingReap, setPendingReap] = useState(null); // { idx, idAcuerdoBitacora, idBitacora, idAcuerdo, comentario }
  
  // Estados para paneles retractibles
  const [expandedPanels, setExpandedPanels] = useState({
    principales: true,
    contacto: true,
    estatus: true,
    comentarios: true
  });
  
  const togglePanel = (panelName) => {
    setExpandedPanels(prev => ({
      ...prev,
      [panelName]: !prev[panelName]
    }));
  };
  
  useEffect(() => {
    const fetchBitacora = async () => {
      try {
        const res = await fetch(RUTAS_BITACORAS.GET_BITACORAID(idBitacora));
        const data = await res.json();
        setBitacora(data);
        setAcuerdos(data.acuerdos || []);
        console.log("Bitácora cargada:", data , idBitacora);
      } catch (error) {
        console.error("Error al cargar la bitácora:", error);
      }
    };
    fetchBitacora();
  }, [idBitacora]);
  
  // Cambiar estatus de acuerdo (1: Pendiente, 2: Completado)
  const toggleEstatusAcuerdo = (idx, idAcuerdoBitacora, idBitacoraParam, idAcuerdo, comentario) => {
    const current = acuerdos[idx];
    const nuevoEstatus = current.estatus === 1 ? 2 : 1;
    
    // Si se está reabriendo (2 -> 1) abrir modal para pedir motivo
    if (current.estatus === 2 && nuevoEstatus === 1) {
      setPendingReap({
        idx,
        idAcuerdoBitacora,
        idBitacora: idBitacoraParam,
        idAcuerdo,
        comentario // comentario actual si quieres enviarlo también
      });
      setReapComentario("");
      setShowReapModal(true);
      return;
    }
    
    // Si se completa (1 -> 2) enviar de inmediato con comentarioReapertura vacío
    enviarActualizacionAcuerdo(idx, idAcuerdoBitacora, idBitacoraParam, idAcuerdo, comentario, nuevoEstatus, "");
  };
  
  // Envia actualización al backend
  const enviarActualizacionAcuerdo = async (idx, idAcuerdoBitacora, idBitacoraParam, idAcuerdo, comentario, nuevoEstatus, comentarioReapertura) => {
    const modelo = {
      idAcuerdoBitacora,
      idBitacora: idBitacoraParam,
      idAcuerdo,
      descripcion: "",
      comentario: comentario || "",
      estatus: nuevoEstatus,
      comentarioReapertura: comentarioReapertura || "",
      fechaCompromiso: "" // No se actualiza esta parte, se mantiene igual en el backend
    };
    
    try {
      const res = await fetch(RUTAS_BITACORAS.UPDATE_ACUERDO_BITACORA, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(modelo)
      });
      
      const data = await res.json().catch(() => ({}));
      if (res.ok) {
        // Actualiza estado local
        const updated = acuerdos.map((a, i) =>
          i === idx ? { ...a, estatus: modelo.estatus } : a
        );
        setAcuerdos(updated);
        alert(data.message || "Estatus actualizado correctamente.");
      } else {
        alert(data.message || "Error al actualizar el estatus del acuerdo.");
      }
    } catch (error) {
      alert("Error de conexión al actualizar el acuerdo.");
      console.error(error);
    } finally {
      // limpiar pending si existía
      setPendingReap(null);
      setShowReapModal(false);
    }
  };
  
  if (!bitacora) return <div className="container mt-4">Cargando...</div>;
  
  // Separar fecha y hora de contacto
  const fechaContactoParts = bitacora.fechaContacto ? bitacora.fechaContacto.split(' ') : ['', ''];
  const fechaContacto = fechaContactoParts[0];
  const horaContacto = fechaContactoParts[1];
  
  const fechaCreacion =  bitacora.fechaCreacion;

  const obtenerTipoContacto = () => {
    if (Number(bitacora?.tipoInt) === 2) return "Agente";
    if (Number(bitacora?.tipoInt) === 1) return "Promotor";
    return bitacora?.tipoInt || "N/A";
  };
  
  return (
    <LayoutGeneral titulo="Bitacora_Seguimiento">
     {/* Modal simple para comentario de reapertura */}
     {showReapModal && pendingReap && (
       <div className="custom-modal-backdrop d-flex justify-content-center align-items-center" style={{ position: "fixed", inset: 0, zIndex: 1050 }}>
         <div className="card" style={{ width: 520 }}>
           <div className="card-header">
             <strong>Motivo de reapertura</strong>
           </div>
           <div className="card-body">
             <div className="mb-2">
               <label>Comentario</label>
               <textarea
                 className="form-control" 
                 rows={4}
                 value={reapComentario}
                 onChange={e => setReapComentario(e.target.value)}
               />
             </div>
             <div className="d-flex justify-content-end gap-2">
               <button className="btn btn-secondary" onClick={() => { setShowReapModal(false); setPendingReap(null); }}>Cancelar</button>
               <button className="btn btn-primary" onClick={() => {
                 // enviar reapertura con comentario
                 enviarActualizacionAcuerdo(
                   pendingReap.idx,
                   pendingReap.idAcuerdoBitacora,
                   pendingReap.idBitacora,
                   pendingReap.idAcuerdo,
                   pendingReap.comentario,
                   1, // nuevo estatus: 1 = pendiente (reabierto)
                   reapComentario && reapComentario.trim() !== "" ? reapComentario.trim() : "Sin comentario"
                 );
               }}>Enviar</button>
             </div>
           </div>
         </div>
       </div>
     )}
      <div className="home-container">
        <aside className="sidebar">
          <ul>
            <li onClick={() => navigate("/Home")}><i className="bi bi-house"></i> Inicio</li>
            {EsAdmin == 1 && (
                <li onClick={() => navigate("/Usuarios")}><i className="bi bi-people"></i> Usuarios</li>
            )}
             {puedeVerReporte && (
                            <li onClick={() => navigate("/Incidencias")}><i className="bi bi-people"></i> Incidencias</li>
                        )}
            <li onClick={() => navigate("/Bitacoras")}><i className="bi bi-journal"></i> Bitácoras</li>
            <li className="logout" onClick={() => { localStorage.clear(); navigate("/"); }}>
              <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
            </li>
          </ul>
        </aside>
        <main className="main-content">
          <h2>
            <button className="btn btn-primary mt-3" onClick={() => navigate("/Bitacoras")}>
              Regresar
            </button>
            <center> <span>Seguimiento de la Bitácora {bitacora.idBitacora} </span> </center> 
          </h2>
          <div className="row mb-3" id="EncabezadoBitacora">
            <div className="col-md-12">
              
              {/* Panel 1: Datos Principales */}
              <div className="card mb-2">
                <div 
                  className="card-header d-flex align-items-center justify-content-between cursor-pointer"
                  onClick={() => togglePanel('principales')}
                  style={{ cursor: 'pointer', backgroundColor: '#b2d3f5' }}
                >
                  <strong>Datos Principales</strong>
                  <i className={`bi bi-chevron-${expandedPanels.principales ? 'down' : 'right'}`} />
                </div>
                {expandedPanels.principales && (
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-md-6"><strong>Oficina:</strong> {bitacora.oficina}</div>
                      <div className="col-md-6"><strong>Tipo Intermediario:</strong> {obtenerTipoContacto()}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6"><strong>Clave Agente:</strong> {bitacora.claveAgente ? bitacora.claveAgente : "N/A"}</div>
                      <div className="col-md-6"><strong>Nombre Agente:</strong> {bitacora.nombreAgente ? bitacora.nombreAgente : "N/A"}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-12"><strong>Actividad:</strong> {bitacora.actividad}</div>
                    </div>
                  </div>
                )}
              </div>

              {/* Panel 2: Datos de Contacto */}
              <div className="card mb-2">
                <div 
                  className="card-header d-flex align-items-center justify-content-between cursor-pointer"
                  onClick={() => togglePanel('contacto')}
                  style={{ cursor: 'pointer', backgroundColor: '#b2d3f5' }}
                >
                  <strong>Datos de Contacto</strong>
                  <i className={`bi bi-chevron-${expandedPanels.contacto ? 'down' : 'right'}`} />
                </div>
                {expandedPanels.contacto && (
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-md-6"><strong>Motivo:</strong> {bitacora.motivoContacto ? bitacora.motivoContacto : "N/A"}</div>
                      <div className="col-md-6"><strong>Tipo Contacto:</strong> {bitacora.tipoContacto}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-6"><strong>Persona:</strong> {bitacora.personaContacto ? bitacora.personaContacto : "N/A"}</div>
                      <div className="col-md-6"><strong>Puesto:</strong> {bitacora.puestoContacto ? bitacora.puestoContacto : "N/A"}</div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-md-3"><strong>Hora de evento:</strong> {horaContacto}</div>
                      <div className="col-md-3"><strong>Duración:</strong> {bitacora.duracion}</div>
                      <div className="col-md-6"><strong>Fecha Contacto:</strong> {fechaContacto}</div>
                    </div>
                  </div>
                )}
              </div>

              {/* Panel 3: Estatus */}
              <div className="card mb-2">
                <div 
                  className="card-header d-flex align-items-center justify-content-between cursor-pointer"
                  onClick={() => togglePanel('estatus')}
                  style={{ cursor: 'pointer', backgroundColor: '#b2d3f5' }}
                >
                  <strong>Estatus</strong>
                  <i className={`bi bi-chevron-${expandedPanels.estatus ? 'down' : 'right'}`} />
                </div>
                {expandedPanels.estatus && (
                  <div className="card-body">
                    <div className="row mb-2">
                      <div className="col-md-3" style={{ fontSize: '1em' }}><strong>Fecha Creación:</strong> {fechaCreacion}</div>
                      <div className="col-md-6" style={{ fontSize: '1.5em' }}>
                        <strong>Estatus de la Bitacora:</strong> 
                        <span className={Number(bitacora.estatus) === 1 ? "text-warning" : "text-success"} style={{ marginLeft: '0.5rem' }}>
                          {Number(bitacora.estatus) === 1 ? "Activa" : "Completado"}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Panel 4: Comentarios */}
              <div className="card mb-2">
                <div 
                  className="card-header d-flex align-items-center justify-content-between cursor-pointer"
                  onClick={() => togglePanel('comentarios')}
                  style={{ cursor: 'pointer', backgroundColor: '#b2d3f5' }}
                >
                  <strong>Comentarios</strong>
                  <i className={`bi bi-chevron-${expandedPanels.comentarios ? 'down' : 'right'}`} />
                </div>
                {expandedPanels.comentarios && (
                  <div className="card-body">
                    <p>{bitacora.comentario || "Sin comentarios"}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <hr />
          <h4>Acuerdos</h4> <br />
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Descripción</th>
                <th>Comentario</th>
                <th>Fecha Compromiso</th>
                <th>Estatus</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              {acuerdos.map((a, idx) => (
                <tr key={a.idAcuerdoBitacora + "-" + a.idAcuerdo}>
                  <td>{idx + 1}</td>
                  <td>{a.descripcion}</td>
                  <td> {a.comentario} </td>
                  <td>{a.fechaCompromiso}</td>
                  <td>
                    <span className={a.estatus === 2 ? "text-success" : "text-warning"}>
                      {a.estatus === 2 ? "Completado" : "Pendiente"}
                    </span>
                  </td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`acuerdoSwitch${idx}`}
                        checked={a.estatus === 2}
                        onChange={() => toggleEstatusAcuerdo(idx, a.idAcuerdoBitacora, a.idBitacora, a.idAcuerdo, a.comentario)}
                      />
                      <label className="form-check-label" htmlFor={`acuerdoSwitch${idx}`}>
                        {a.estatus === 2 ? "Completado" : "Pendiente"}
                      </label>
                    </div>
                  </td>
                </tr>
              ))}
              {acuerdos.length === 0 && (
                <tr>
                  <td colSpan={6} className="text-center">No hay acuerdos registrados.</td>
                </tr>
              )}
            </tbody>
          </table>
        </main>
      </div>
    </LayoutGeneral>
  );
};

export default Bitacora_Seguimiento;